import {
  Box,
  Container,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export function InfoSection() {
  return (
    <Box
      component="section"
      sx={{ py: { xs: 6, md: 8 }, bgcolor: "background.default" }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: { xs: 4, md: 8 },
        }}
      >
        <Box
          component="img"
          src="https://umsousercontent.com/lib_wfKJyoksALKsfAWv/uqkzd0qrwa9wckdt.png?w=1200&h=900&fit=max&dpr=2"
          alt="Box Illustration"
          sx={{ flex: 1, maxWidth: { xs: "100%", md: 400 }, width: "100%" }}
        />
        <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>
          <Typography variant="h4" gutterBottom>
            Your bond paid when you need it
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 3 }}>
            Your dream place is closer than you think.
          </Typography>
          <List disablePadding>
            {[
              {
                primary: "Same Day Bond Payment",
                secondary:
                  "We aim to process your bond as soon as possible as we know how important it is for you to get it fast!",
              },
              {
                primary:
                  "Just 4 easy interest free payments",
                secondary:
                  "With BondPay you’ll pay a small $99 + first instalment of the bond upfront with no hidden cost",
              },
              {
                primary: "Earn $60 Cash Back",
                secondary: "Earn $60 in cash back by connecting your Utilities",
              },
            ].map((item, idx) => (
              <ListItem key={idx} alignItems="flex-start" sx={{ px: 0 }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      bgcolor: "transparent",
                      color: "primary.dark",
                      border: "1px solid",
                      borderColor: "grey.400",
                    }}
                  >
                    <ArrowForwardIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={item.primary}
                  secondary={item.secondary}
                />
              </ListItem>
            ))}
          </List>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent={{ xs: "center", md: "flex-start" }}
            sx={{ mt: 4 }}
          >
            {["Easy online application", "Stress-free moving"].map(
              (text, idx) => (
                <Stack
                  key={idx}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                >
                  <CheckCircleIcon color="success" />
                  <Typography>{text}</Typography>
                </Stack>
              )
            )}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
